import React, { lazy, Suspense } from "react";
import Backdrop from "components/common-components/backdrop";

const Default = lazy(() => import("../../../../layouts/dashboard/default"));
const OnboardingListing = lazy(() => import("../pages/onboarding-listing"));
const OnboardingTasksListing = lazy(() =>
  import("../pages/onboarding-task-listing")
);
const OnboardingTaskDetails = lazy(() =>
  import("../pages/onboarding-task-details")
);
const OnboardingManagerApprovalListing = lazy(() =>
  import("../pages/onboarding-approval-listing")
);
const OnboardingProfileDetails = lazy(() =>
  import("../pages/onboarding-profile-details")
);
const OnboardingManager = lazy(() => import("../pages/onboarding-manager"));
const OnboardingDashboard = lazy(() => import("../pages/onboarding-dashboard"));

export const OnboardingRouter = [
  {
    path: "onboarding",
    element: (
      <Suspense fallback={<Backdrop />}>
        <Default />
      </Suspense>
    ),
    children: [
      {
        path: "listing",
        element: (
          <Suspense fallback={<Backdrop />}>
            <OnboardingListing />
          </Suspense>
        ),
      },
      {
        path: "dashboard",
        element: (
          <Suspense fallback={<Backdrop />}>
            <OnboardingDashboard />
          </Suspense>
        ),
      },
      {
        path: "manager",
        element: (
          <Suspense fallback={<Backdrop />}>
            <OnboardingManager />
          </Suspense>
        ),
      },
      {
        path: "onboarding-task-Approval-listing",
        element: (
          <Suspense fallback={<Backdrop />}>
            <OnboardingManagerApprovalListing />
          </Suspense>
        ),
      },
      {
        path: "onboarding-task-profile-details",
        element: (
          <Suspense fallback={<Backdrop />}>
            <OnboardingProfileDetails />
          </Suspense>
        ),
      },
      {
        path: "onboarding-task-details/:id",
        element: (
          <Suspense fallback={<Backdrop />}>
            <OnboardingTaskDetails />
          </Suspense>
        ),
      },
      {
        path: "onboarding-tasks",
        element: (
          <Suspense fallback={<Backdrop />}>
            <OnboardingTasksListing />
          </Suspense>
        ),
      },
    ],
  },
];
